module.exports = ['$scope', 'forgetPasswordService', '$state', 'User', '$ionicPopup', '$translate', '$phoneModal', '$utils',
  function ($scope, forgetPasswordService, $state, User, $ionicPopup, $translate, $phoneModal, $utils) {
    $scope.forgetPassword = {
    }
    // 邮箱验证页初始化
    if ($state.current.name === 'emailValidation') {
      $scope.forgetPassword.account = sessionStorage.getItem('forgetPassword_email')
      initVerifyCode()
    }
    // 短信验证页初始化
    if ($state.current.name === 'getPasswordViaPhone') {
      $scope.forgetPassword.number = sessionStorage.getItem('forgetPassword_phoneNumber')
      $scope.forgetPassword.account = sessionStorage.getItem('forgetPassword_email')
      if (!$scope.forgetPassword.number || !$scope.forgetPassword.account) {
        ionicAlert('LOGIN.NO_EMAIL_PHONE_VALIDATION').then(() => {
          $state.go('login')
        })
      } else {
        $scope.number = $scope.forgetPassword.number.substring($scope.forgetPassword.number.length - 4) // 手机号倒数4位
      }
    }
    // 重置密码页初始化
    if ($state.current.name === 'resetPassword') {
      $scope.forgetPassword.message_verifyCode = sessionStorage.getItem('forgetPassword_message_verifyCode')
      $scope.forgetPassword.account = sessionStorage.getItem('forgetPassword_email')
      if (!$scope.forgetPassword.message_verifyCode || !$scope.forgetPassword.account) {
        ionicAlert('LOGIN.NO_EMAIL_PHONE_VALIDATION').then(() => {
          $state.go('login')
        })
      }
      forgetPasswordService.getPasswordPolicy({}).then(function (data) {
        $scope.strengthData = data
        $scope.minStrength = data.minStrength
        $scope.passwordTip = data.tip
        $scope.currentPasswordStrength = ''
      }, function () {
      })
    }
    // 返回
    $scope.goBack = function () {
      const currentState = $state.current.name
      switch (currentState) {
        case 'resetPassword':
          $state.go('getPasswordViaPhone')
          break
        case 'getPasswordViaPhone':
          $state.go('emailValidation')
          break
        // case 'emailValidation':
        //   $state.go('login')
        //   break
        default:
          $state.go('login')
      }
    }
    // 初始化邮箱验证码
    function initVerifyCode() {
      forgetPasswordService.getVerifyCodeImgSrc().then(function (data) {
        $scope.forgetPassword.verifyCodeImgSrc = data
      }, function () { })
    }
    // 刷新邮箱验证码
    $scope.refreshVerifyCode = function () {
      forgetPasswordService.getVerifyCodeImgSrc().then(function (data) {
        $scope.forgetPassword.verifyCodeImgSrc = data
      }, function () { })
    }

    function ionicAlert(i18nKey) {
      return $ionicPopup.alert({
        template: $translate.instant(i18nKey),
        okType: 'button-default',
        okText: $translate.instant('OP.YES')
      })
    }
    // 确认邮箱验证
    $scope.confirmEmailValidation = function () {
      forgetPasswordService.confirmAccountValidation($scope.forgetPassword.account, $scope.forgetPassword.verifyCode).then(function () {
        $state.go('getPasswordViaPhone')
        $utils.$notify.set({ message: $translate.instant('LOGIN.SEND_VERIFYCODE_DONE') })
      }, function (error) {
        switch (error.code) {
          case 'FA_EMPTY_PHONE': // 未绑定手机号
            ionicAlert('LOGIN.FA_EMPTY_PHONE')
            break
          case 'FA_INVALID_VERIFY_CODE': // 验证码输入错误
            ionicAlert('LOGIN.ENTER_WRONG_VERIFY_CODE')
              .then(() => {
                $scope.refreshVerifyCode()
              })
            break
          case 'FR_INVALID_REQUEST':
            ionicAlert('LOGIN.FR_INVALID_REQUEST')
              .then(() => {
                $scope.refreshVerifyCode()
              })
            break
          case 'FA_TOO_FREQUENTLY': // 操作过于频繁，请稍后再试
            ionicAlert('LOGIN.FA_TOO_FREQUENTLY')
            break
          default: // 邮箱验证失败
            ionicAlert('LOGIN.ACCOUNT_VALIDATE_WENT_WRONG')
              .then(() => {
                $scope.refreshVerifyCode()
              })
        }
      })
    }
    // 确认手机验证码验证
    $scope.confirmCellPhoneVerifyCode = function () {
      forgetPasswordService.confirmVerifyCodeByCell($scope.forgetPassword.account, $scope.forgetPassword.message_verifyCode).then(function () {
        $state.go('resetPassword')
      }, function (error) {
        if (error.code === 'FA_INVALID_VERIFY_CODE') {
          ionicAlert('LOGIN.ENTER_WRONG_MESSAGE_VERIFY_CODE')
        } else {
          ionicAlert('LOGIN.MESSAGE_VALIDATION_WENT_WRONG')
        }
      })
    }
    // 确认重置密码
    $scope.confirmResetPassword = function () {
      if ($scope.forgetPassword.new_password !== $scope.forgetPassword.confirm_password) {
        ionicAlert('LOGIN.NOT_SAME_PASSWORD')
        return
      }
      forgetPasswordService.confirmResetPassword($scope.forgetPassword.account, $scope.forgetPassword.message_verifyCode, $scope.forgetPassword.new_password).then(function () {
        openResetPasswordSuccessModal()
      }, function () {
        ionicAlert('LOGIN.RESET_PASSWORD_FAIL')
      })
    }
    // 打开密码重置成功反馈模态框
    function openResetPasswordSuccessModal() {
      $scope.resetPasswordSuccessModal = $phoneModal.fromTemplate(require('views/login/forgetPassword/resetPasswordSuccessModal.html'), {
        scope: $scope,
        cache: false,
        animation: 'slide-in-up'
      })
      $scope.resetPasswordSuccessModal.el.style.zIndex = 11
      $utils.$modalFunc.prepareModalBack($scope.resetPasswordSuccessModal)
      $scope.resetPasswordSuccessModal.show()
    }
    // 关闭密码重置成功反馈模态框
    $scope.closeResetPasswordSuccessModal = function () {
      $scope.resetPasswordSuccessModal.remove()
    }
    // 重新登录
    $scope.reLogin = function () {
      $scope.resetPasswordSuccessModal.remove()
      $state.go('login')
    }
    // 处理输入框变化
    $scope.handleInputValueChange = function (type) {
      switch (type) {
        case 'account':
          $scope.showAccountClearIcon = !!$scope.forgetPassword.account
          break
        case 'verifyCode':
          $scope.showVerifyCodeClearIcon = !!$scope.forgetPassword.verifyCode
          break
        case 'message_verifyCode':
          $scope.showMessageVerifyCodeClearIcon = !!$scope.forgetPassword.message_verifyCode
          break
        case 'new_password':
          $scope.showNewPasswordClearIcon = !!$scope.forgetPassword.new_password
          refreshPasswordStrengthStatus()
          break
        case 'confirm_password':
          $scope.showConfirmPasswordClearIcon = !!$scope.forgetPassword.confirm_password
          break
      }
    }
    // 清空输入框的值
    $scope.clearInputValue = function (type) {
      switch (type) {
        case 'account':
          $scope.forgetPassword.account = ''
          inputFocus(type)
          break
        case 'verifyCode':
          $scope.forgetPassword.verifyCode = ''
          inputFocus(type)
          break
        case 'message_verifyCode':
          $scope.forgetPassword.message_verifyCode = ''
          inputFocus(type)
          break
        case 'new_password':
          $scope.forgetPassword.new_password = ''
          inputFocus(type)
          break
        case 'confirm_password':
          $scope.forgetPassword.confirm_password = ''
          inputFocus(type)
          break
      }
      function inputFocus(type) {
        setTimeout(function () {
          const inputItem = document.querySelector(`#${type}`)
          inputItem.focus()
        })
      }
    }
    // 处理表单失焦事件
    $scope.handleInputBlur = function (type) {
      switch (type) {
        case 'account':
          $scope.showAccountClearIcon = false
          break
        case 'verifyCode':
          $scope.showVerifyCodeClearIcon = false
          break
        case 'message_verifyCode':
          $scope.showMessageVerifyCodeClearIcon = false
          break
        case 'new_password':
          $scope.showNewPasswordClearIcon = false
          $scope.warningText = isPassStrength($scope.forgetPassword.new_password, $scope.strengthData.rules[$scope.strengthData.minStrength])
          break
        case 'confirm_password':
          $scope.showConfirmPasswordClearIcon = false
          break
        default:
          return null
      }
    }
    // 处理表单聚焦事件
    $scope.handleInputFocus = function (type) {
      switch (type) {
        case 'account':
          $scope.showAccountClearIcon = !!$scope.forgetPassword.account
          break
        case 'verifyCode':
          $scope.showVerifyCodeClearIcon = !!$scope.forgetPassword.verifyCode
          break
        case 'message_verifyCode':
          $scope.showMessageVerifyCodeClearIcon = !!$scope.forgetPassword.message_verifyCode
          break
        case 'new_password':
          $scope.showNewPasswordClearIcon = !!$scope.forgetPassword.new_password
          $scope.warningText = ''
          refreshPasswordStrengthStatus()
          break
        case 'confirm_password':
          $scope.showConfirmPasswordClearIcon = !!$scope.forgetPassword.confirm_password
          break
        default:
          return null
      }
    }
    // 显示密码
    $scope.setPasswordVisibility = function (type) {
      if (type === 'new_password') {
        $scope.showNewPassword = !$scope.showNewPassword
      }
      if (type === 'confirm_password') {
        $scope.showConfirmPassword = !$scope.showConfirmPassword
      }
    }
    // input focus和input change的时候 更新页面视图 密码强度状态
    function refreshPasswordStrengthStatus() {
      const strength = getPasswordStrength($scope.forgetPassword.new_password, $scope.strengthData.rules)
      $scope.strength_type = `strength-${strength}`
      switch (strength) {
        case 'zero':
          $scope.strength_value = 0
          $scope.strength_text = $translate.instant('LOGIN.WEAK')
          break
        case 'WEAK':
          $scope.strength_value = 25
          $scope.strength_text = $translate.instant('LOGIN.WEAK')
          break
        case 'FAIR':
          $scope.strength_value = 50
          $scope.strength_text = $translate.instant('LOGIN.FAIR')
          break
        case 'GOOD':
          $scope.strength_value = 75
          $scope.strength_text = $translate.instant('LOGIN.GOOD')
          break
        case 'STRONG':
          $scope.strength_value = 100
          $scope.strength_text = $translate.instant('LOGIN.STRONG')
          break
      }
    }
    // 计算密码强度
    function getPasswordStrength(password, rules) {
      let strength = ''
      if (!password) {
        return 'zero'
      }
      const strengthArr = Object.keys(rules)
      for (let i = 0; i < strengthArr.length; i++) {
        if (isPassStrength(password, rules[strengthArr[i]])) {
          break
        } else {
          strength = strengthArr[i]
        }
      }
      return strength
    }
    // 判断密码是否通过指定强度, 返回警告文字表示不通过，返回空字符串表示不通过
    function isPassStrength(password, strengthRule) {
      const ruleKeys = Object.keys(strengthRule)
      let warningText = ''
      if (!password) {
        return warningText
      }
      for (let i = 0; i < ruleKeys.length; i++) {
        if (!strengthRule[ruleKeys[i]](password)) {
          warningText = getWarningText(ruleKeys[i])
          break
        }
      }
      return warningText
    }
    // 根据规则返回对应的警告文字
    function getWarningText(rule) {
      const warningText = {
        isOverMinLength: $translate.instant('LOGIN.OVER_MINLENGTH', { count: $scope.strengthData.minLength === 0 ? 1 : $scope.strengthData.minLength }),
        isNoProhibit: $translate.instant('LOGIN.NO_PROHIBIT'),
        isNoSameWithUsername: $translate.instant('LOGIN.NO_SAME_WITH_USERNAME'),
        isDiffCharacter: $translate.instant('LOGIN.DIFF_CHARACTER'),
        isNoConsecutive: $translate.instant('LOGIN.NO_CONSECUTIVE'),
        isIncludeTwoType: $translate.instant('LOGIN.INCLUDE_TWO_TYPE'),
        isIncludeThreeType: $translate.instant('LOGIN.INCLUDE_THREE_TYPE'),
      }
      return warningText[rule]
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/login/forgetPasswordCtrl.js